export default __webpack_public_path__ + "static/media/2_0150.a64e03a4.webp";